import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import Main from './main';
import { Provider } from 'react-redux';
import store from './store/store';
import { log } from './logger';
import { eventNames as appEvent } from './config';
console.log(tizen.tvinputdevice.getSupportedKeys(), 'supported keys');
log(appEvent.START_APP);
tizen.tvinputdevice.registerKeyBatch(['ChannelUp', 'ChannelDown']);
// console.log(tizen, 'tizen api');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Main />
    </Provider>
  </React.StrictMode>
);
